import { apiRequest } from './apiClient';
import {
  NOTIFICATIONS_PENDING,
  NOTIFICATIONS_STATUS,
  NOTIFICATIONS_SUBSCRIBE,
} from './constants';
import {
  NotificationAckType,
  NotificationsRealtimePayload,
} from '../../types/Notifications/types';
import { debugNotificationsLog } from '../../utils/notificationsProtocol';

export const postNotifications = async (token: string): Promise<boolean> => {
  if (!token) return false;

  try {
    const { success, error } = await apiRequest('post', NOTIFICATIONS_SUBSCRIBE, { tokens: [token] });

    if (!success) console.error('[postNotifications] failed to submit token:', error);

    return success;
  } catch (error) {
    console.error('[postNotifications] failed to submit token:', error);
    return false;
  }
};

export const getPendingNotifications = async (): Promise<NotificationsRealtimePayload[]> => {
  try {
    const { data } = await apiRequest<object[]>('get', NOTIFICATIONS_PENDING);

    if (!Array.isArray(data)) return [];

    return data as NotificationsRealtimePayload[];
  } catch (error) {
    debugNotificationsLog('Error obteniendo notificaciones pendientes por HTTP', error);
    return [];
  }
};

export const updateNotificationState = async (
  id: string,
  estado: NotificationAckType,
): Promise<boolean> => {
  try {
    await apiRequest(
      'put',
      `${NOTIFICATIONS_STATUS}/${id}/estado`,
      { estado },
    );
    return true;
  } catch (error) {
    debugNotificationsLog('Error actualizando estado de notificación por HTTP', {
      id,
      estado,
      error,
    });
    return false;
  }
};
